import { HStack, List, ListItem, StackProps } from "@biblioteksentralen/react";
import { Limelight } from "next/font/google";
import InternalLink from "../InternalLink";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { usePathname } from "next/navigation";
import { capitalize } from "radash";
import { getGradeLabel, getGradePath, grades } from "./sommerlesPopularReading";
import { SommerlesButton } from "./SommerlesButton";

const limelightFont = Limelight({ subsets: ["latin"], weight: "400" });

const SommerlesPopularReadingLinks = (props: StackProps) => {
  const { t } = useTranslation();
  const pathName = usePathname();

  return (
    <HStack
      as={List}
      flexWrap="wrap"
      spacing="0.5rem"
      width="100%"
      className={limelightFont.className}
      sx={{
        "h1,h2": limelightFont.style,
        containerType: "inline-size",
      }}
      {...props}
    >
      {grades.map((grade) => {
        return (
          <ListItem key={grade}>
            <SommerlesButton as={InternalLink} href={getGradePath(grade)} disabled={pathName.endsWith(`${grade}`)}>
              {capitalize(getGradeLabel(grade, t))}
            </SommerlesButton>
          </ListItem>
        );
      })}
    </HStack>
  );
};

export default SommerlesPopularReadingLinks;
